export default __webpack_public_path__ + "static/media/Logo Phoenix.d320cf04.png";